const PREFIX = "@HIGHGROUND_GLOBAL_";

export const MSP_DASHBOARD_DATE_PICKER_STATE = `${PREFIX}MSP_DASHBOARD_DATE_PICKER_STATE`;
export const MSP_SPEND_MODAL_DATE_PICKER_STATE = `${PREFIX}MSP_SPEND_MODAL_DATE_PICKER_STATE`;
